function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomNightlifeViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.599 27.136h2.397v-1.598H18.6v-.799h2.397v-1.598H18.6v-.799h2.397v-1.598H18.6v-1.598h5.794v8.79h1.598v-9.59c0-.441-.357-.798-.799-.798H17.8a.798.798 0 00-.8.799v9.588H18.6v-.799z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.734a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.734V4.07H4.133z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.745 5.682c-3.212.511-6.374 2.835-5.262 7.886.58 2.627 3.9 4.257 7.112 3.746a5.889 5.889 0 003.65-2.107s-5.643.205-7.12-2.556c-1.477-2.76.52-5.648 1.62-6.969z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.782 9.226l-1-1 .99-.99 1 1-.99.99zM21.501 15.569l-1-1 .99-.99 1 1-.99.99zM11.672 25.566l-1-1 .99-.99 1 1-.99.99zM7.693 22.741l-1-1 .99-.99 1 1-.99.99zM23.642 8.45l-1-1 .99-.99 1 1-.99.99z",
    fill: props.color
  }));
}

export default SvgIconRoomNightlifeViewFilled;